import { styled } from '@mui/system';
import { Button, ListItemText } from '@mui/material';
import { IconClose } from 'assets/icons';

const PopupStyle = styled('div', {target: 'PopupStyle'})(({ theme }) => ({
  borderRadius: theme.spacing(1),
  overflowWrap: 'break-word',
  wordBreak: 'break-word',
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-evenly',
  top: '40%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'clamp(300px,90%, 540px)',
  maxWidth: '100vw',
  maxHeight: '100vh',
  padding: theme.spacing(1),
  background: '#fff',
  textAlign: 'center',
  overflow: 'auto',
}));


const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  color: theme.vars.palette.primary.textColor,
  margin: 0,
  display: 'flex',
  textAlign: 'center',
  padding: theme.spacing(1),
  fontSize: '0.875rem',
  height: 'auto',
  "& .MuiTypography-body1": {
    fontWeight: 500,
    margin: 'auto'
  },
  "& .MuiTypography-body2": {
    fontWeight: 400,
    margin: 'auto'
  }
}));

const TextWrapper = styled('div', {target: 'TextWrapper'})(({ theme }) => ({
  margin: theme.spacing(1,0,1,0),
  whiteSpace: 'pre-line'
}));

const CustomButton = styled(Button)(({ theme }) => ({
  alignSelf: 'center',
  border: `1px solid ${theme.vars.palette.primary.main}`,
  marginTop: theme.spacing(2),
  maxWidth: '90%',
  height: '40px',
  fontSize: '1rem'
}));

const WhiteButton = styled(CustomButton)(({theme}) => ({
  marginBottom: theme.spacing(3),
  paddingLeft: '32px',
  paddingRight: '32px',
  fontSize: '0.875rem',
  '& > span':{
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  '&:hover':{
    boxShadow: `0px 2px 8px rgb(${theme.vars.palette.primary.mainChannel} / 0.2)`,
    background: '#fff'
  },
}));

const CloseButton = styled(Button, 'CloseButton')(({ theme }) => ({
  minWidth: 0,
  marginLeft: 'auto',
  cursor: 'pointer'
}))

const SvgStyle = styled('div', {target: 'SvgStyle'})(({theme})=> ({
  marginTop: theme.spacing(2)
}))

export {
  PopupStyle,
  StyledListItemText,
  TextWrapper,
  WhiteButton,
  SvgStyle,
  CloseButton
}